// Column Types
export const ColumnType = {
  TEXT: 'text',
  COUNTER: 'counter',
  TOGGLE: 'toggle',
  MENU: 'menu',
  DOWNLOAD: 'download',
  VIEW: 'view',
  Date:'Date',
  SubText:'subText'
};

// Table Column Interface
export const TableColumnConfig = {
  field: '',
  header: '',
  type: ColumnType.TEXT,
  formatter: null,
  width: null,
  sortable: true,
  filterable: true
};

// Action Column Interface
export const ActionColumnConfig = {
  status: {
    enabled: false,
    onChange: null
  },
  menu: {
    enabled: false,
    items: []
  },
  download: {
    enabled: false,
    onClick: null
  },
  view: {
    enabled: false,
    onClick: null
  },
  approve: {
    enabled: false,
    onClick: null
  },
  reject: {
    enabled: false,
    onClick: null
  }
};

// Table Configuration Interface
export const TableConfig = {
  columns: [],
  data: [],
  actions: ActionColumnConfig,
  loading: false,
  pagination: {
    enabled: true,
    rows: 10,
    totalRecords: 0
  },
  sorting: {
    enabled: true,
    defaultSortField: null,
    defaultSortOrder: null
  },
  filtering: {
    enabled: true,
    globalFilter: true
  }
};